module.exports = require("./mgh.js");